import React, { useEffect } from 'react'
import HomePageLayout from 'Pages/Layout/PageLayout'
import { connect, useDispatch } from 'react-redux'
import { RootState } from 'Store'
import { Badge, Card, Col, Divider, Row, Space } from 'antd'
import { LoadingView } from 'Components/modal'
import styled from 'styled-components'
import Theme, { MyTheme } from 'Components/common/Theme'
import { CheckCircleTwoTone, UserOutlined } from '@ant-design/icons'
import { PrimaryButton } from 'Components/button'
import { selectCurrentUser } from 'Store/user/selector'
import { PackagesSpecData, PackagesSpecReq } from 'Store/pos/types'
import { getPackagesSpecAPI } from 'Store/pos/api'
import { selectActionEvent, selectPackagesSpec } from 'Store/pos/selector'
import { numberWithComma } from 'helpers/format'
import { sortingByNumber, sortingList } from 'helpers/sorting'
import { cloneDeep } from 'lodash'
import { useNavigate } from 'react-router-dom'

type Props = {} & ReduxProps

const PosPackages: React.FunctionComponent<Props> = props => {
  const { currentUser, packageSpec } = props

  const dispatch = useDispatch()
  const history = useNavigate()

  const onGetPackageSpec = (): void => {
    const req: PackagesSpecReq = {}
    dispatch(getPackagesSpecAPI(req, currentUser.accessToken, currentUser?.activeMerchant?.id || ''))
  }

  const onRegister = (id: number): void => {
    history(`/pos/packages/${id}`)
  }

  useEffect(() => {
    if (currentUser?.accessToken) {
      onGetPackageSpec()
    }
  }, [])

  const renderPackageData = (data: PackagesSpecData) => {
    const isCanBuy = data.is_buy === true
    const isCanRenew = data.is_buy === false && data.activate === true
    const showBadge = !isCanBuy && isCanRenew
    const card = (
      <Wrapper hoverable style={{ paddingBottom: showBadge ? '40px' : 0 }}>
        <WrapperSpace align="center" direction="vertical" size="small">
          <Title>{data.name}</Title>
          <Description>{data.description}</Description>
        </WrapperSpace>
        <Divider />
        <WrapperSpace align="center" direction="vertical" size="small">
          <Description>ราคาเริ่มต้น</Description>
          <Price>{numberWithComma(data.price)}</Price>
          <Description>บาท/เดือน</Description>
        </WrapperSpace>
        <Divider />
        <WrapperSpace align="start" direction="vertical" size="small">
          {data.properties.map((item: string, index: number) => {
            return (
              <Space key={index} align="start">
                <CheckCircleTwoTone twoToneColor={Theme.colors.primary} />
                <List>{item}</List>
              </Space>
            )
          })}
        </WrapperSpace>
        <Divider />
        <ButtonWrapper>
          {isCanBuy ? (
            <PrimaryButton text={'ซื้อแพ็กเกจ'} btnType="Approve" onClick={() => onRegister(data.id)} />
          ) : isCanRenew ? (
            <PrimaryButton text={'ต่ออายุการใช้งาน'} onClick={() => onRegister(data.id)} />
          ) : (
            // <PrimaryButton text={'คุณซื้อแพ็กเกจนี้แล้ว'} disabled={true} onClick={() => {}} />
            <PrimaryButton text={'ต่ออายุการใช้งาน'} onClick={() => onRegister(data.id)} />
          )}
        </ButtonWrapper>
      </Wrapper>
    )

    if (showBadge) {
      return (
        <Badge.Ribbon text="แพ็กเกจปัจจุบัน" color="green">
          {card}
        </Badge.Ribbon>
      )
    }

    return card
  }

  const packages = sortingByNumber(cloneDeep(packageSpec.data), 'asc', 'price')

  return (
    <HomePageLayout selected="pos" title="เลือกแพ็กเกจและราคาค่าบริการ">
      <LoadingView isShow={packageSpec.event.IsLoading} />
      {/* <Curve /> */}
      {/* <EventModal event={[event]} enable={true} successCalback={onSuccess} errorCalback={clearEvent} /> */}
      {/* <Row justify="center">
        <Col>เลือกแพ็กเกจและราคาค่าบริการ</Col>
      </Row> */}
      <PackageWrapper>
        <Row justify="center" gutter={[16, 16]}>
          {packages &&
            packages.map((item: PackagesSpecData, index: number) => {
              return (
                <Col lg={6} md={12} xs={24} key={index}>
                  {renderPackageData(item)}
                </Col>
              )
            })}
        </Row>
      </PackageWrapper>
    </HomePageLayout>
  )
}

const Wrapper = styled(Card)`
  width: 100%;
  border-radius: 20px;
  background-color: #fff;
  padding: 0 10px;
  text-align: center;
  height: 100%;
`

const WrapperSpace = styled(Space)`
  width: 100%;
`

const PackageWrapper = styled.div`
  margin-top: 30px;
`

const ButtonWrapper = styled.div`
  //width: 100%;
  margin-top: 30px;
  text-align: center;
  position: absolute;
  bottom: 8px;
  left: 10px;
  right: 10px;
`

const Title = styled.div`
  margin-top: 30px;
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.h5};
`

const Price = styled.div`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.h1};
`

const Description = styled.div`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.grey};
`

const List = styled.div`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
  text-align: left;
`

// const Curve = styled.div`
//   position: fixed;
//   height: 300px;
//   width: calc(100% + 200px);
//   overflow: hidden;
//   background-color: #f39f20;
//   bottom: 0;
//   right: 0;
//   border-radius: 50% 50% 0 0 / 100% 100% 0 0;
//   z-index: 0;
//   left: 0;
//   background-attachment: fixed;

//   @media only screen and (max-width: 991px) {
//     height: 200px;
//     width: calc(100% + 60px);
//   }
// `

const mapStateToProps = (state: RootState) => {
  return {
    currentUser: selectCurrentUser(state),
    event: selectActionEvent(state),
    packageSpec: selectPackagesSpec(state),
  }
}

type ReduxProps = ReturnType<typeof mapStateToProps>

export default connect(mapStateToProps)(PosPackages)
